module.exports = __webpack_public_path__ + "static/media/pefin-assistant-01.90b016fb.png";